import useRebrandVersion from 'hooks/useRebrandVersion'
import type { _BaseButtonKind } from 'LuxKit/Button/BaseButton'

/**
 * Kind for the "View gallery" button overlaid on drawer hero imagery.
 *
 * The legacy dark secondary button reads as barely-there against a photo, so
 * rebrand promotes it to primary.
 */
function useGalleryButtonKind(): _BaseButtonKind {
  return useRebrandVersion() === 'rebrand' ? 'primary' : 'secondary'
}

export default useGalleryButtonKind
